"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doWithinTimeout = void 0;
/**
 * Resolves given promise within the given `timeoutMs` argument, or rejects otherwise.
 */
async function doWithinTimeout(promise, timeoutMs) {
    let timeoutId;
    const timeoutPromise = new Promise((_, reject) => {
        timeoutId = setTimeout(
        // Push timeout handling to the end of the microtask queue, in case the promises resolve at the same time
        () => setImmediate(() => reject(new Error(`Operation timed out after ${timeoutMs}ms`))), timeoutMs);
    });
    return Promise.race([promise.finally(() => clearTimeout(timeoutId)), timeoutPromise]);
}
exports.doWithinTimeout = doWithinTimeout;
//# sourceMappingURL=do-within-timeout.js.map